import React from "react";
import MarketAnalysisComponent from "../../components/marketAnalysisComponents/MarketAnalysisComponent";

export interface MarketAnalysisContainerProps {
    isTabSelected: boolean
}

const MarketAnalysisContainer: React.FC<MarketAnalysisContainerProps> = ({isTabSelected}) => {
    return (<MarketAnalysisComponent isTabSelected={isTabSelected} />);
};

export default MarketAnalysisContainer;
